module.exports = __webpack_public_path__ + "img/logo.2b636b36.png";